// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bakz3","left":"styles_left__2jgL8"};